import * as React from 'react';

import { isPopupScopeExist, usePopupScope } from '../Popup';
import type { TooltipStatefulProps } from '../Tooltip';
import type { ButtonView } from './Button.types';

export const inverseViews = new Set<ButtonView>(['primary']);
export const staticViews = new Set<ButtonView>(['media']);
export const contrastViews = new Set<ButtonView>(['primary', 'media']);

export const checkedInverseViews = new Set<ButtonView>(['secondary', 'surface']);

export const viewsWithCheckedState = new Set<ButtonView>([
    'secondary',
    'outline',
    'ghost',
    'surface',
]);

export function useHrButtonDefaultTooltipProps() {
    const { popupScope } = usePopupScope();
    const boundary = isPopupScopeExist(popupScope) ? popupScope : undefined;

    return {
        hrButtonDefaultTooltipProps: React.useMemo<Partial<TooltipStatefulProps>>(
            () => ({
                size: 's',
                direction: ['bottom', 'top'],
                trimText: false,
                trigger: ['hover', 'focus'],
                mainOffset: 8,
                hasTail: false,
                boundary,
            }),
            [boundary],
        ),
    };
}
